import * as Icon from 'react-feather';
import mood from "../assets/images/ref/mood.jpeg"
import medicalpark from "../assets/images/ref/medicalpark.png"
import memorial from "../assets/images/ref/memorial.png"
import ibb from "../assets/images/ref/ibb.png"
import safa from "../assets/images/ref/safa.jpeg"
import beykoz from "../assets/images/ref/beykoz.jpeg"
import esenyurt from "../assets/images/ref/esenyurt.png"
import cerrahpasa from "../assets/images/ref/cerrahpasa.png"
import yeniyzyl from "../assets/images/ref/yyuni.png"
import boyner from "../assets/images/ref/boyner.jpeg"
import inka from "../assets/images/ref/inka.png"
import thy from"../assets/images/ref/thy.png"
import sarkuysan from "../assets/images/ref/sarkuysan.png"
import trendyol from "../assets/images/ref/trendyol.jpeg"
import reno from "../assets/images/ref/renault.jpeg"
import esneklik from "../assets/images/blogs/esneklik.png"
import terapi from "../assets/images/blogs/terapi.png"
import blog3 from "../assets/images/blogs/blog3.png"
export const expertiseData = [
    {
        title:'MOODİST PSİKİYATRİ & NÖROLOJİ HASTANESİ',
        Icon: mood
    },
    {
        title:'MEDICALPARK',
        Icon: medicalpark
    },
    {
        title:'MEMORIAL',
        Icon: memorial
    },
    {
        title:'İSTANBUL BÜYÜKŞEHİR BELEDİYESİ',
        Icon: ibb
    },
    {
        title:'SAFA HASTANESİ',
        Icon: safa
    },
    {
        title:'BEYKOZ BELEDİYESİ',
        Icon: beykoz
    },
    {
        title:'İSTANBUL ESENYURT ÜNİVERSİTESİ',
        Icon: esenyurt
    },
    {
        title:'İSTANBUL ÜNİVERSİTESİ CERRAHPAŞA',
        Icon: cerrahpasa
    },
    {
        title:'İSTANBUL YENİ YÜZYIL ÜNİVERSİTESİ',
        Icon: yeniyzyl
    },
    {
        title:'BOYNER',
        Icon: boyner
    },
    {
        title:'İNKA İNSAN KAYNAKLARI',
        Icon: inka
    },
    {
        title:'TÜRK HAVA YOLLARI',
        Icon: thy
    }, 
    {
        title:'SANKUYSAN',
        Icon: sarkuysan,
    }, 
    {
        title:'TRENDYOL',
        Icon: trendyol
    }, 
    {
        title:'RENAULT',
        Icon: reno
    }, 
]
export const servicesData = [
    {
        title:'Öfke Kontrolü Testi',
        desc:'Öfke kontrolü testi öfke seviyesi, kontrol becerileri ve ifade şekliyle ilişkili sonuçlar göstermektedir.',
        Icon: Icon.Airplay
    },
    {
        title:'Depresyon Testi',
        desc:'Depresyon testi, depresif belirtilerin şiddetini ölçmek amacıyla hazırlanmış bir ölçektir.',
        Icon: Icon.Aperture
    },
   /*  {
        title:'Beck Anksiyete Ölçeği',
        desc:'The phrasal sequence of the is now so that many campaign and benefit',
        Icon: Icon.Camera
    },
    {
        title:'Graphic Designer',
        desc:'The phrasal sequence of the is now so that many campaign and benefit',
        Icon: Icon.Compass
    },
    {
        title:'Web Security',
        desc:'The phrasal sequence of the is now so that many campaign and benefit',
        Icon: Icon.Settings
    },
    {
        title:'Web Security',
        desc:'The phrasal sequence of the is now so that many campaign and benefit',
        Icon: Icon.Watch
    },
 */
]
export const project = [
   {
    image: '/images/works/1.jpg',
    title:'Fronter Theme',
    subTitle: 'UI / UX Design',
   },
   {
    image: '/images/works/2.jpg',
    title:'Fronter Theme',
    subTitle: 'UI / UX Design',
   },
   {
    image: '/images/works/3.jpg',
    title:'Fronter Theme',
    subTitle: 'UI / UX Design',
   },
   {
    image: '/images/works/4.jpg',
    title:'Fronter Theme',
    subTitle: 'UI / UX Design',
   },
   {
    image: '/images/works/5.jpg',
    title:'Fronter Theme',
    subTitle: 'UI / UX Design',
   },
   {
    image: '/images/works/6.jpg',
    title:'Fronter Theme',
    subTitle: 'UI / UX Design',
   },
   {
    image: '/images/works/7.jpg',
    title:'Fronter Theme',
    subTitle: 'UI / UX Design',
   },
   {
    image: '/images/works/8.jpg',
    title:'Fronter Theme',
    subTitle: 'UI / UX Design',
   }
   
]
export const blogData = [
    {
        image:esneklik,
        title:'Psikolojik Esneklik',
        desc:'Psikolojik esneklik, duruma ve kişisel değerlere göre davranışlarını seçerken, hoş olmayan düşünce, duygu ve bedensel duyumlardan bağımsız olarak şu an ile temas halinde kalma yeteneğidir. Araştırmalar, psikolojik esnekliğin yaşam kalitesi ve zihinsel iyilik hali ile ilişkili olduğunu ve semptomların azalmasına aracılık edebileceğini göstermektedir.'


    },
    {
        image:blog3,
         title:'Sağlıklı İlişki',
         desc:'Sevgi, saygı ve güven temeliyle oluşturulan ilişkilerde bu üç madde çiftler arasındaki bağı kuvvetlendiren bütün unsurların beslenmesine katkı sağlamaktadır. Öyle ki, bir tanesinin yokluğu büyük sarsılmalara ve ilişkinin sonlanmasına sebep olabilir. Sağlıklı bir ilişkide sevgi, saygı ve güvenin yanında duygu ve düşünceleri doğru aktarabilecek doğru bir iletişim de ilişkilerde kritik bir etkendir. Doğru bir üslup ve doğru bir dil, tarafları çözülmesi zor meseleleri bile sevgi ve saygı çerçevesinde ortak bir noktada çözmeye iter. Böylece aradaki bağ daha da kuvvetlenir. Bu bağın kuvvetlenmesi birlikte yapılacak programlar, gezilecek yerler veya aranızda büyütüp beslemek isteyeceğiniz her ne varsa tüm bunlar için yol oluşturur. Birlikte emek vermek ve ortak hedefler ilişkiyi olumlu yönde etkiler. Tüm bu durumların yanında özel alanların ihmal edilmemesi de bireylerin ilişkideki özgürlüğünü hissedebilmesi açısından güvende hissettirecek ve olası ihtimallerde bilinçaltında tehdit uyaranı oluşturmayacaktır.'
     },
    {
        image:terapi,
        title:'Terapi Süreci',
        desc:'Terapi sürecine başlamak uzun bir yolculuktur.Bu yolculukta terapistinizle iş birliği ve güven yolculuğun en temel özelliklerinden birisidir.Ancak zaman zaman hoşlanmadığınız ve sizi rahatsız eden durumlarla karşı karşıya kaldığınızda yüzleşmek bu süreçte sizi kötü hissettirebilir.Hatta terapistinize karşı öfke, kızgınlık vb. yoğun duygular yansıtabilirsiniz. Bu uzun yolculuğun bir parçası olarak karşınıza çıkmaktadır. Mutlu ve huzurlu bir hafta dileğiyle .'
    },
   
]
export const review = [
    {
        name:'Thomas Israel',
        designation:'Manager',
        image:'/images/client/01.jpg',
        desc:"Obviously I'm a Web Designer. Web Developer with over 7 years of experience. Experienced with all stages of the development."
    },
   {
        name:'Thomas Israel',
        designation:'Manager',
        image:'/images/client/01.jpg',
        desc:"Obviously I'm a Web Designer. Web Developer with over 7 years of experience. Experienced with all stages of the development."
    },
    {
        name:'Thomas Israel',
        designation:'Manager',
        image:'/images/01.jpg',
        desc:"Obviously I'm a Web Designer. Web Developer with over 7 years of experience. Experienced with all stages of the development."
    },
    {
        name:'Thomas Israel',
        designation:'Manager',
        image:'/images/client/01.jpg',
        desc:"Obviously I'm a Web Designer. Web Developer with over 7 years of experience. Experienced with all stages of the development."
    },
    {
        name:'Thomas Israel',
        designation:'Manager',
        image:'/images/client/01.jpg',
        desc:"Obviously I'm a Web Designer. Web Developer with over 7 years of experience. Experienced with all stages of the development."
    }, 
]
export const test=[
    {
        title:"Öfke Kontrolü Testi",
        question:"1.Çabuk Parlarım"
    },
    {
        title:"Öfke Kontrolü Testi",
        question:"2.Kızgın mizaçlıyımdır."
    },
    {
        title:"Öfke Kontrolü Testi",
        question:"3.Öfkesi burnunda bir insanım."
    },
    {
        title:"Öfke Kontrolü Testi",
        question:"4.Başkalarının hataları, yaptığım işi yavaşlatınca kızarım."
    },
  
    {
        title:"Öfke Kontrolü Testi",
        question:"5.Yaptığım iyi bir işten sonra takdir edilmemek canımı sıkar."
    },
    {
        
        title:"Öfke Kontrolü Testi",
        question:"6.Öfkelenince kontrolümü kaybederim."
    },
    {
        
        title:"Öfke Kontrolü Testi",
        question:"7.Öfkelendiğimde ağzıma geleni söylerim."
    },
    {
        
        title:"Öfke Kontrolü Testi",
        question:"8.Başkalarının önünde eleştirilmek beni çok hiddetlendirir."
    },
    {
        
        title:"Öfke Kontrolü Testi",
        question:"9.Engellendiğimde içimden birilerine vurmak gelir."
    },
    {
        
        title:"Öfke Kontrolü Testi",
        question:"10.Yaptığım iyi bir iş kötü değerlendirildiğinde çılgına dönerim."
    },
    {
        
        title:"Öfke Kontrolü Testi",
        question:"11.Öfkemi kontrol ederim."
    },
    {
        
        title:"Öfke Kontrolü Testi",
        question:"12.Kızgınlığımı gösteririm."
    },
    {
        
        title:"Öfke Kontrolü Testi",
        question:"13.Öfkemi içime atarım."
    },
    {
        
        title:"Öfke Kontrolü Testi",
        question:"14.Başkalarına karşı sabırlıyımdır."
    },
    {
        
        title:"Öfke Kontrolü Testi",
        question:"15.Somurtur ya da surat asarım."
    },
    {
        
        title:"Öfke Kontrolü Testi",
        question:"16.İnsanlardan uzak dururum."
    },
    {
        
        title:"Öfke Kontrolü Testi",
        question:"17.Başkalarına iğneli sözler söylerim."
    },
    {
        
        title:"Öfke Kontrolü Testi",
        question:"18.Soğukkanlılığımı korurum."
    },
    {
        
        title:"Öfke Kontrolü Testi",
        question:"19.Kapıları çarpmak gibi şeyler yaparım."
    },
    {
        
        title:"Öfke Kontrolü Testi",
        question:"20.İçin için köpürürüm ama gösteremem."
    },
    {
        
        title:"Öfke Kontrolü Testi",
        question:"21.Davranışlarımı kontrol ederim."
    },
    {
        
        title:"Öfke Kontrolü Testi",
        question:"22.Başkalarıyla tartışırım."
    },
    {
        
        title:"Öfke Kontrolü Testi",
        question:"23.İçimde, kimseye söylemediğim kinler beslerim."
    },
    {
        
        title:"Öfke Kontrolü Testi",
        question:"24.Beni çileden çıkaran her neyse saldırırım."
    },
    {
        
        title:"Öfke Kontrolü Testi",
        question:"25.Öfkem kontrolden çıkmadan kendimi durdurabilirim."
    },
    {
        
        title:"Öfke Kontrolü Testi",
        question:"26.Gizliden gizliye insanları epeyce eleştiririm."
    },
    {
        
        title:"Öfke Kontrolü Testi",
        question:"27.Belli ettiğimden daha öfkeliyimdir."
    },
    {
        
        title:"Öfke Kontrolü Testi",
        question:"28.Çoğu kimseye kıyasla daha çabuk sakinleşirim."
    },
    {
        
        title:"Öfke Kontrolü Testi",
        question:"29.Kötü şeyler söylerim."
    },
    {
        title:"Öfke Kontrolü Testi",
        
        question:"30.Hoşgörülü ve anlayışlı olmaya çalışırım."
    },
    {
        
        title:"Öfke Kontrolü Testi",
        question:"31.İçimden insanların fark ettiğinden daha fazla sinirlenirim."
    },
    {
        
        title:"Öfke Kontrolü Testi",
        question:"32.Sinirlerime hakim olamam."
    },
    {
        
        title:"Öfke Kontrolü Testi",
        question:"33.Beni sinirlendirene, ne hissettiğimi söylerim."
    },
    {
        
        title:"Öfke Kontrolü Testi",
        question:"34.Kızgınlık duygularımı kontrol ederim."
    },
]

export const test1=[
    {
        title:"Depresyon Testi",
        question:"Son 1 hafta içinde",
        data:["Kendimi üzgün hissetmiyorum","Kendimi üzgün hissediyorum.","Her zaman için üzgünüm ve kendimi bu duygudan kurtaramıyorum.","Öylesine üzgün ve mutsuzum ki, dayanamıyorum."]
    },
    {
        title:"Depresyon Testi",
        question:"Son 1 hafta içinde",
        data:["Gelecek hakkında umutsuz ve karamsar değilim.","Gelecek hakkında karamsarım.","Gelecekten beklediğim hiçbir şey yok.","Geleceğim hakkında umutsuzum ve sanki hiçbir şey düzelmeyecekmiş gibi geliyor."]
    },
    {
        title:"Depresyon Testi",
        question:"Son 1 hafta içinde",
        data:["Kendimi başarısız görmüyorum.","Çevremdeki birçok kişiden daha fazla başarısızlıklarım oldu sayılır.","Geriye dönüp baktığımda, çok fazla başarısızlığımın olduğunu görüyorum.","Kendimi tümüyle başarısız bir insan olarak görüyorum."]
    },
    {
        title:"Depresyon Testi",
        question:"Son 1 hafta içinde",
        data:["Her şeyden eskisi kadar zevk alabiliyorum.","Her şeyden eskisi kadar zevk alamıyorum.","Artık hiçbir şeyden gerçek bir zevk alamıyorum.","Bana zevk veren hiçbir şey yok. Her şey çok sıkıcı."]
    },
    {
        title: "Depresyon Testi",
        question: "Son 1 hafta içinde",
        data: [
            "Kendimi suçlu hissetmiyorum.",
            "Arada bir kendimi suçlu hissettiğim oluyor.",
            "Kendimi çoğunlukla suçlu hissediyorum.",
            "Kendimi her an için suçlu hissediyorum."
        ]
    },
    {
        title: "Depresyon Testi",
        question: "Son 1 hafta içinde",
       data: [
            "Cezalandırıldığımı düşünmüyorum.",
            "Bazı şeyler için cezalandırılabileceğimi hissediyorum.",
            "Cezalandırılmayı bekliyorum.",
            "Cezalandırıldığımı hissediyorum."
        ]
    },
    {
        title: "Depresyon Testi",
        question: "Son 1 hafta içinde",
       data: [
            "Kendimden hoşnutum.",
            "Kendimden pek hoşnut değilim.",
            "Kendimden hiç hoşlanmıyorum.",
            "Kendimden nefret ediyorum."
        ]
    },
    {
        title: "Depresyon Testi",
        question: "Son 1 hafta içinde",
       data: [
            "Kendimi diğer insanlardan daha kötü görmüyorum.",
            "Kendimi zayıflıklarım ve hatalarım için eleştiriyorum.",
            "Kendimi hatalarım için çoğu zaman suçluyorum.",
            "Her kötü olayda kendimi suçluyorum."
        ]
    },
    {
        title: "Depresyon Testi",
        question: "Son 1 hafta içinde",
       data: [
            "Kendimi öldürmek gibi düşüncelerim yok.",
            "Bazen kendimi öldürmeyi düşünüyorum, fakat bunu yapmam.",
            "Kendimi öldürebilmeyi isterdim.",
            "Bir fırsatını bulsam kendimi öldürürdüm."
        ]
    },
    {
        title: "Depresyon Testi",
        question: "Son 1 hafta içinde",
       data: [
            "Her zamankinden daha fazla ağladığımı sanmıyorum.",
            "Eskisine göre şu sıralarda daha fazla ağlıyorum.",
            "Şu sıralarda her an ağlıyorum.",
            "Eskiden ağlayabilirdim, ama şu sıralarda istesem de ağlayamıyorum."
        ]
    },
    {
        title: "Depresyon Testi",
        question: "Son 1 hafta içinde",
       data: [
            "Her zamankinden daha sinirli değilim.",
            "Her zamankinden daha kolayca sinirleniyorum ve kızıyorum.",
            "Çoğu zaman sinirliyim.",
            "Eskiden sinirlendiğim şeylere bile artık sinirlenemiyorum."
        ]
    },
    {
        title: "Depresyon Testi",
        question: "Son 1 hafta içinde",
       data: [
            "Diğer insanlara karşı ilgimi kaybetmedim.",
            "Eskisine göre insanlarla daha az ilgiliyim.",
            "Diğer insanlara karşı ilgimin çoğunu kaybettim.",
            "Diğer insanlara karşı hiç ilgim kalmadı."
        ]
    },
    {
        title: "Depresyon Testi",
        question: "Son 1 hafta içinde",
       data: [
            "Kararlarımı eskisi kadar kolay ve rahat verebiliyorum.",
            "Şu sıralarda kararlarımı vermeyi erteliyorum.",
            "Kararlarımı vermekte oldukça güçlük çekiyorum.",
            "Artık hiç karar veremiyorum."
        ]
    },
    {
        title: "Depresyon Testi",
        question: "Son 1 hafta içinde",
       data: [
            "Dış görünüşümün eskisinden daha kötü olduğunu sanmıyorum.",
            "Yaşlandığımı ve çekiciliğimi kaybettiğimi düşünüyor ve üzülüyorum.",
            "Dış görünüşümde artık değiştirilmesi mümkün olmayan olumsuz değişiklikler olduğunu hissediyorum.",
            "Çok çirkin olduğumu düşünüyorum."
        ]
    },
    {
        title: "Depresyon Testi",
        question: "Son 1 hafta içinde",
       data: [
            "Her zamankinden daha iyi çalışabiliyorum.",
            "Bir işe başlayabilmek için eskisine göre kendimi daha fazla zorlamam gerekiyor.",
            "Hangi iş olursa olsun, yapabilmek için kendimi çok zorluyorum.",
            "Hiç bir iş yapamıyorum."
        ]
    },
    {
        title: "Depresyon Testi",
        question: "Son 1 hafta içinde",
       data: [
            "Eskisi kadar rahat uyuyabiliyorum.",
            "Şu sıralarda eskisi kadar rahat uyuyamıyorum.",
            "Eskisine göre 1 veya 2 saat erken uyanıyor ve tekrar uyumakta zorluk çekiyorum.",
            "Eskisine göre çok erken uyanıyor ve tekrar uyuyamıyorum."
        ]
    },
    {
        title: "Depresyon Testi",
        question: "Son 1 hafta içinde",
       data: [
            "Eskisine kıyasla daha çabuk yorulduğumu sanmıyorum.",
            "Eskisinden daha çabuk yoruluyorum.",
            "Şu sıralarda neredeyse her şey beni yoruyor.",
            "Öyle yorgunum ki, hiç bir şey yapamıyorum."
        ]
    },
    {
        title: "Depresyon Testi",
        question: "Son 1 hafta içinde",
       data: [
            "İştahım eskisinden pek farklı değil.",
            "İştahım eskisi kadar iyi değil.",
            "Şu sıralarda iştahım epey kötü.",
            "Artık hiç iştahım yok."
        ]
    },
    {
        title: "Depresyon Testi",
        question: "Son 1 hafta içinde",
       data: [
            "Son zamanlarda pek fazla kilo kaybettiğimi sanmıyorum.",
            "Son zamanlarda istemediğim halde üç kilodan fazla kaybettim.",
            "Son zamanlarda istemediğim halde beş kilodan fazla kaybettim.",
            "Son zamanlarda istemediğim halde yedi kilodan fazla kaybettim."
        ]
    },
    {
        title: "Depresyon Testi",
        question: "Son 1 hafta içinde",
       data: [
            "Sağlığım beni pek endişelendirmiyor.",
            "Son zamanlarda ağrı, sızı, mide bozukluğu, kabızlık gibi sorunlarım var.",
            "Ağrı, sızı gibi sıkıntılarım beni epey endişelendirdiği için başka şeyleri düşünmek zor geliyor.",
            "Bu tür sıkıntılar beni öylesine endişelendiriyor ki, artık başka hiçbir şey düşünemiyorum."
        ]
    },
    {
        title: "Depresyon Testi",
        question: "Son 1 hafta içinde",
       data: [
            "Son zamanlarda cinsel yaşantımda dikkatimi çeken hiçbir şey yok.",
            "Eskisine göre cinsel konularla daha az ilgileniyorum.",
            "Şu sıralarda cinsellikle pek ilgili değilim.",
            "Artık, cinsellikle hiçbir ilgim kalmadı."
        ]
    },
    ]
export const me =[
    {
        Eğitimler: [
        "Psikodinamik Terapi Eğitimi Otto Kernberg",
          "Kişilik Bozuklukları Otto Kernberg",
          "Bilişsel Davranışçı Terapi - Prof. Dr. Hakan Türkçapar",
          "Bdt Travma-Prof. Dr. Hakan Türkçapar",
          "Borderline K.b. Şema Terapi-Dr. Alp Karaosmanoğlu",
          "Beck Yönelimli CBT nedir-Dr.Emel Stroup",
          "Psikodinamik Terapi-Prof.Dr.Sibel Mercan",
          "Psikoterapide Düşünceler -Prof. Dr. Hakan Türkçapar",
          "Grup Terapisi -Dr.Pervin Sevda Bıkmaz",
          "Bağımlılığa Yaklaşım -UzmPsk. Kinyas Tekin",
          "Görüşme Teknikleri-Prof.Dr.Burcu Çakaloz",
          "EMDR Travma Psikoterapisi- Uzm.Psk.Bahattin Göktan",
          "Bilişsel Psikoloji-Dr.Ayhan Karay",
          "Aktarım OdaklıTerapi -Psk. Olcay Yaman",
          "Bilişsel Davranışçı Terapi-Dr.Sema Yeşilyurt",
          "Psikodinamik Terapi -Dr.Cihat Çıtak",
          "Süpervizyon-Doç.Dr.Burcu Rahşan",
          "Çocuk Psikopatolojisi-Dr.Necmettin Aksoy",
          "Süpervizyon-Dr.Fadime Yurtseven",
          "Mindfulness Terapi- Psk.Nilüfer Şişman",
          "Projektif Testler-Dr.Umut Yıldız"
        ],
        persons: [
          "Prof.Dr.KEMAL ARIKAN",
          "Prof.Dr.Salih ÖZDEN",
          "Prof.Dr.ÖGET ÖKTEM TANÖR",
          "DR.AYHAN KARAY",
          "DR.ASİL BUDAKLI",
          "DR.LEVENT BAKIŞGAN"
        ]
      }
      
]
